import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { BREAKPOINTS } from '@hookdeck/theme';
import Button from '../../../common/base/Button';
import Container from '../../../common/base/Container';
import { Div } from '../../../common/helpers/StyledUtils';
import useViewportBreakpoint from '../../../hooks/useViewportBreakpoint';
import MetricDatePicker, { useDateRange } from '../../DashboardScene/Metrics/MetricDatePicker';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavActions, StyledViewNavHeader, ViewBreadcrumbsTitle } from '../../../layouts/ViewLayout';
import MetricChart from './MetricChart';
import MetricTableChart from './MetricTableChart';
import Divider from '../../../common/base/Divider';
import ChartInteractionGroup from '../../../common/Chart/ChartInteractionGroup';
const columns_for_breakpoints: Record<keyof typeof BREAKPOINTS, number> = {
  mobile: 1,
  tablet: 2,
  laptop: 2,
  desktop: 3
};
const MetricsView: React.FC = () => {
  const $ = _c(82);
  const breakpoint = useViewportBreakpoint();
  const [date_range, onDateRangeChanged] = useDateRange();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Date.now();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [refresh_key, setRefreshKey] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "Metrics",
      highlight: true
    }];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const breadcrumbs = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== date_range || $[4] !== onDateRangeChanged) {
    t3 = <MetricDatePicker date_range={date_range} onDateRangeChanged={onDateRangeChanged} />;
    $[3] = date_range;
    $[4] = onDateRangeChanged;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button outline={true} icon="reload" onClick={() => setRefreshKey(Date.now())}>Reload</Button>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <StyledViewNav><StyledViewNavHeader>{t2}<StyledViewNavActions>{t3}{t4}</StyledViewNavActions></StyledViewNavHeader></StyledViewNav>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onDateRangeChanged) {
    t6 = range => onDateRangeChanged({
      relative: undefined,
      min: range.min,
      max: range.max
    });
    $[9] = onDateRangeChanged;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      b: 8,
      t: 6
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = columns_for_breakpoints[breakpoint] >= 3 ? 3 : columns_for_breakpoints[breakpoint];
  let t9;
  if ($[12] !== t8) {
    t9 = {
      columns: t8,
      gap: 6
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ["count"];
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== date_range || $[16] !== refresh_key) {
    t11 = <MetricChart height={520} title="Events count" chart_type="bar" metric_type="count" endpoint="events" measures={t10} value_key="Events.count" time_key="Events.createdAt" tooltip_label="Events" date_range={date_range} refresh_key={refresh_key} />;
    $[15] = date_range;
    $[16] = refresh_key;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["count"];
    t13 = ["tenant_id"];
    $[18] = t12;
    $[19] = t13;
  } else {
    t12 = $[18];
    t13 = $[19];
  }
  let t14;
  if ($[20] !== date_range || $[21] !== refresh_key) {
    t14 = <MetricChart height={520} title="Events per tenant" chart_type="bar" metric_type="count" endpoint="events" measures={t12} dimensions={t13} value_key="Events.count" time_key="Events.createdAt" dimension_key="Events.tenant_id" tooltip_label="Events" date_range={date_range} refresh_key={refresh_key} />;
    $[20] = date_range;
    $[21] = refresh_key;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["count"];
    t16 = ["topic"];
    $[23] = t15;
    $[24] = t16;
  } else {
    t15 = $[23];
    t16 = $[24];
  }
  let t17;
  if ($[25] !== date_range || $[26] !== refresh_key) {
    t17 = <MetricChart height={520} title="Events per topic" chart_type="bar" metric_type="count" endpoint="events" measures={t15} dimensions={t16} value_key="Events.count" time_key="Events.createdAt" dimension_key="Events.topic" tooltip_label="Events" date_range={date_range} refresh_key={refresh_key} />;
    $[25] = date_range;
    $[26] = refresh_key;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = ["count"];
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== date_range || $[30] !== refresh_key) {
    t19 = <MetricChart title="Events rate" chart_type="line" metric_type="rate" endpoint="events" measures={t18} value_key="Events.count" time_key="Events.createdAt" tooltip_label="Events" date_range={date_range} refresh_key={refresh_key} />;
    $[29] = date_range;
    $[30] = refresh_key;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = ["count"];
    t21 = ["tenant_id"];
    $[32] = t20;
    $[33] = t21;
  } else {
    t20 = $[32];
    t21 = $[33];
  }
  let t22;
  if ($[34] !== date_range || $[35] !== refresh_key) {
    t22 = <MetricTableChart title="Events per tenant" endpoint="events" measures={t20} dimensions={t21} date_range={date_range} refresh_key={refresh_key} />;
    $[34] = date_range;
    $[35] = refresh_key;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  let t24;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = ["count"];
    t24 = ["topic"];
    $[37] = t23;
    $[38] = t24;
  } else {
    t23 = $[37];
    t24 = $[38];
  }
  let t25;
  if ($[39] !== date_range || $[40] !== refresh_key) {
    t25 = <MetricTableChart title="Events per topic" endpoint="events" measures={t23} dimensions={t24} date_range={date_range} refresh_key={refresh_key} />;
    $[39] = date_range;
    $[40] = refresh_key;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t11 || $[43] !== t14 || $[44] !== t17 || $[45] !== t19 || $[46] !== t22 || $[47] !== t25 || $[48] !== t9) {
    t26 = <Div grid={t9}>{t11}{t14}{t17}{t19}{t22}{t25}</Div>;
    $[42] = t11;
    $[43] = t14;
    $[44] = t17;
    $[45] = t19;
    $[46] = t22;
    $[47] = t25;
    $[48] = t9;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Divider m={{
      y: 12
    }} />;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  const t28 = columns_for_breakpoints[breakpoint] >= 3 ? 3 : columns_for_breakpoints[breakpoint];
  let t29;
  if ($[51] !== t28) {
    t29 = {
      columns: t28,
      gap: 6
    };
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      b: 20
    };
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = ["count"];
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== date_range || $[56] !== refresh_key) {
    t32 = <MetricChart height={520} title="Delivery attempts count" chart_type="bar" metric_type="count" endpoint="attempts" measures={t31} value_key="Attempts.count" time_key="Attempts.createdAt" tooltip_label="Deliveries" datasets_type="stacked" date_range={date_range} refresh_key={refresh_key} />;
    $[55] = date_range;
    $[56] = refresh_key;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = ["successful_count", "failed_count"];
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  let t34;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = [{
      key: "successful_count",
      label: "Successful",
      theme_color: "success"
    }, {
      key: "failed_count",
      label: "Failed",
      theme_color: "danger"
    }];
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  let t35;
  if ($[60] !== date_range || $[61] !== refresh_key) {
    t35 = <MetricChart height={520} title="Delivery attempts by status" chart_type="bar" metric_type="count" endpoint="attempts" measures={t33} value_key="Attempts.successful_count" time_key="Attempts.createdAt" tooltip_label="Deliveries" series={t34} datasets_type="stacked" date_range={date_range} refresh_key={refresh_key} />;
    $[60] = date_range;
    $[61] = refresh_key;
    $[62] = t35;
  } else {
    t35 = $[62];
  }
  let t36;
  let t37;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = ["tenant_id"];
    t37 = ["error_rate"];
    $[63] = t36;
    $[64] = t37;
  } else {
    t36 = $[63];
    t37 = $[64];
  }
  let t38;
  if ($[65] !== date_range || $[66] !== refresh_key) {
    t38 = <MetricChart height={520} title="Error rate per tenant" chart_type="line" metric_type="percent" endpoint="attempts" dimensions={t36} measures={t37} value_key="Attempts.error_rate" time_key="Attempts.createdAt" dimension_key="Attempts.tenant_id" tooltip_label="Average attempt" date_range={date_range} refresh_key={refresh_key} />;
    $[65] = date_range;
    $[66] = refresh_key;
    $[67] = t38;
  } else {
    t38 = $[67];
  }
  let t39;
  if ($[68] !== t29 || $[69] !== t32 || $[70] !== t35 || $[71] !== t38) {
    t39 = <Div grid={t29} m={t30}>{t32}{t35}{t38}</Div>;
    $[68] = t29;
    $[69] = t32;
    $[70] = t35;
    $[71] = t38;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  if ($[73] !== t26 || $[74] !== t39) {
    t40 = <Container left={true} m={t7}>{t26}{t27}{t39}</Container>;
    $[73] = t26;
    $[74] = t39;
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] !== t40 || $[77] !== t6) {
    t41 = <ChartInteractionGroup onTimeRangeSelected={t6}>{t40}</ChartInteractionGroup>;
    $[76] = t40;
    $[77] = t6;
    $[78] = t41;
  } else {
    t41 = $[78];
  }
  let t42;
  if ($[79] !== t41 || $[80] !== t5) {
    t42 = <StyledViewLayout><StyledViewContent>{t5}{t41}</StyledViewContent></StyledViewLayout>;
    $[79] = t41;
    $[80] = t5;
    $[81] = t42;
  } else {
    t42 = $[81];
  }
  return t42;
};
export default MetricsView;